import axios, { AxiosRequestConfig } from 'axios'
import { InjectionKey } from 'vue'
import { createStore, Store, useStore as baseUseStore, ActionContext } from 'vuex'
import { compile } from 'path-to-regexp'
import { forEach } from 'lodash-es'
import user, { UserProps } from './user'
import example, { ExampleProps } from './example'
import template, { TemplateProps } from './template'
import resume, { ResumeProps } from './resume'
import order, { OrderProps } from './order'
import balance, { BalanceProps } from './balance'
import token, { TokenProps } from './token'
import global, { GlobalStatus } from './global'
export interface GlobalDataProps {
  user: UserProps;
  example: ExampleProps;
  template: TemplateProps;
  resume: ResumeProps;
  order: OrderProps;
  balance: BalanceProps;
  token: TokenProps;
  global: GlobalStatus;
}
export const key: InjectionKey<Store<GlobalDataProps>> = Symbol()
export interface ActionPayload {
  urlParams?: { [key: string]: any };
  data?: any;
  searchParams?: { [key: string]: any };
}
type ICustomAxiosConfig = AxiosRequestConfig & {
  loadedKey?: string;
  disableCaching?: boolean;
}
export function actionWrapper(url: string, commitName: string, 
  config: ICustomAxiosConfig = { method: 'get', loadedKey: 'isLoaded' }) {
  // 第一步 不管三七二十一，先返回一个函数和原来的函数处理一摸一样
  return async (context: ActionContext<any, any>, payload: ActionPayload = {}) => {
    //第三部 写内部重复的逻辑
    const { urlParams, data, searchParams } = payload
    const { loadedKey, disableCaching } = config
    const { state, commit } = context
    console.log(payload)
    // 检查数据是否已经加载，如果加载完毕，直接返回
    if (loadedKey && state[loadedKey] && !disableCaching) {
      return
    }
    const newConfig = { ...config, data, opName: commitName }
    let newURL = url
    if (urlParams) {
      const toPath = compile(url, { encode: encodeURIComponent })
      newURL = toPath(urlParams)
      console.log(newURL)
    }
    if (searchParams) {
      const search = new URLSearchParams()
      forEach(searchParams, (value, key) => {
        search.append(key, value)
      })
      newURL += '?' + search.toString()
      // 另外一种方式
      // newURL += '?' + objToQueryString(searchParams)
    }
    const resp = await axios(newURL, newConfig)
    commit(commitName, { payload ,...resp.data})
    return resp.data
  }
}
// define your own `useStore` composition function
export function useStore () {
  return baseUseStore(key)
}
export default createStore({
  modules: {
    user,
    example,
    template,
    resume,
    order,
    global,
    balance,
    token
  }
})
